import { render, staticRenderFns } from "./Nurses.vue?vue&type=template&id=6b37f545&"
import script from "./Nurses.vue?vue&type=script&lang=js&"
export * from "./Nurses.vue?vue&type=script&lang=js&"
import style0 from "./Nurses.vue?vue&type=style&index=0&id=6b37f545&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports